import React from 'react';

import ResourceForm, { FormFieldDefinition, ResourceFormProps } from '../components/./Form/ResourceForm';
import { InputType } from '../components/./Form/types';

const formFields: FormFieldDefinition<'event_streets'>[] = [
  {
    attribute: 'streetId',
    label: 'Straat',
    required: true,
    type: InputType.Search,
    resourceType: 'streets',
  },
  {
    attribute: 'eventId',
    type: InputType.Hidden,
  },
];

const EventStreetForm = (props: Partial<ResourceFormProps<'event_streets'>>) => (
  <ResourceForm fields={formFields} type="event_streets" {...props} />
);

export default EventStreetForm;
